import { createSlice } from "@reduxjs/toolkit";

export const DEFAULT_EXPENSE_DATE_BASIS = "voucher_order_date";
const DISABLED_EXPENSE_DATE_BASIS = ["payment_date"];

const sanitizeExpenseDateBasis = (value) => {
  if (!value || DISABLED_EXPENSE_DATE_BASIS.includes(value)) {
    return DEFAULT_EXPENSE_DATE_BASIS;
  }
  return value;
};

const initialState = {
  expenseDateBasis: DEFAULT_EXPENSE_DATE_BASIS,
};

export const AppConfigSlice = createSlice({
  name: "appConfig",
  initialState,
  reducers: {
    SET_EXPENSE_DATE_BASIS: (state, action) => {
      state.expenseDateBasis = sanitizeExpenseDateBasis(action.payload);
    },
  },
});

export const { SET_EXPENSE_DATE_BASIS } = AppConfigSlice.actions;
export default AppConfigSlice.reducer;
